import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
//import thunk from 'redux-thunk';
import rootReducer from './rootReducer';

const storageConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['offerDetails'],
};

const persistedReducer = persistReducer(storageConfig, rootReducer);
//const store = createStore(persistedReducer, applyMiddleware(thunk));
const store = configureStore({
  reducer: persistedReducer,
  // Including middleware if you need any custom configuration
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializableCheck because redux-persist uses non-serializable values
    }),
});
const persistor = persistStore(store);

const persistConfig = { store, persistor };
export default persistConfig;
